import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import FormattedPrice from '@/components/Base/Formats/FormattedPrice.vue';
import blueCheckoutService from '@/services/blue/CheckoutService';
import popupManager from '@/services/Dom/PopupManager';
import eventBus from '@/services/EventBus';
import CouponUsageBlock from '@/components/Base/Coupons/CouponUsageBlock.vue';
import { CouponType } from '@/models/account/Coupon';
export default defineComponent({
    name: 'blue-checkout-checkout-box',
    components: {
        CouponUsageBlock,
        FormattedPrice,
    },
    mounted() {
        this.pullCart();
    },
    data() {
        return {
            start_final_checkout: false,
            initial: true,
        };
    },
    methods: Object.assign(Object.assign({}, mapActions('blue', {
        confirmCouponCodeInStore: 'SET_COUPON_CODE',
        removeCouponInStore: 'REMOVE_COUPON_CODE',
        loadCoupons: 'LOAD_COUPONS',
        pullCart: 'PULL_CART',
        stopCheckout: 'STOP_CHECKOUT',
    })), { confirmCouponCode: function (code) {
            return this.confirmCouponCodeInStore(code);
        }, removeCoupon() {
            return this.removeCouponInStore();
        },
        showPopUp() {
            popupManager.showPopup('garantie');
        },
        confirm_purchase() {
            this.initial = false;
            eventBus.emit('ShowLoadingOverlay');
            if (this.start_final_checkout) {
                return;
            }
            if (this.valid_for_checkout === false) {
                this.failConfirm();
                return;
            }
            this.start_final_checkout = true;
            blueCheckoutService
                .submit()
                .then((successful) => {
                if (successful === true) {
                    // when successful a redirect is send to the browser. to prevent further user-interaction we
                    // will not hide the loading animation and replace the grayish_overlay with a
                    // deep clone to get rid of all listeners, since otherwise it can be discarded with
                    // a simple click (see header.js::32)
                    const overlay = document.getElementById('grayish_overlay');
                    if (overlay) {
                        overlay.replaceWith(overlay.cloneNode(true));
                    }
                    return;
                }
                this.failConfirm();
            })
                .catch(() => {
                this.failConfirm();
            });
        },
        failConfirm() {
            this.start_final_checkout = false;
            eventBus.emit('HideLoadingOverlay');
            this.stopCheckout();
            const invalids = document.querySelectorAll('.is-invalid');
            invalids.forEach((invalid) => {
                invalid.classList.add('was-validated');
                invalid.classList.add('nope-shake');
            });
            if (invalids.length > 0) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                window.scrollToAnker(invalids.item(0));
            }
        } }),
    computed: Object.assign(Object.assign(Object.assign(Object.assign({ CouponType() {
            return CouponType;
        } }, mapGetters('account', {
        isLogin: 'isLogin',
    })), mapGetters('blue', {
        currentPaymentType: 'currentPaymentType',
        cart_totals: 'cartTotals',
        currentCouponCode: 'currentCouponCode',
        current_products: 'currentProducts',
    })), mapState('blue', {
        valid_for_checkout: 'valid_for_checkout',
        coupons: 'coupons',
    })), { totals: function () {
            return this.cart_totals;
        }, hasWarrantyForAll() {
            let hasWarranty = true;
            if (this.current_products.length === 0) {
                return false;
            }
            this.current_products.forEach((product) => {
                hasWarranty = hasWarranty && product.has_extended_warranty_month === 36;
            });
            return hasWarranty;
        } }),
});
